import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Header } from './Header';
import { HeroSystem } from './HeroSystem';
import { OfferLearning } from './OfferLearning';
import { RecipesAccess } from './RecipesAccess';
import { TrustFooter } from './TrustFooter';
export function LandingPage() {
  useScreenInit();
  return <div className="min-h-screen w-full overflow-hidden bg-[#fcfbf7] text-[#344833]" data-id="element-163">
      <Header data-id="element-164" />
      <main data-id="element-165">
        <HeroSystem data-id="element-166" />
        <OfferLearning data-id="element-167" />
        <RecipesAccess data-id="element-168" />
        <TrustFooter data-id="element-169" />
      </main>
    </div>;
}